module.exports = __webpack_public_path__ + "img/7007160.png";